import { Injectable } from '@angular/core';
import { LoggingService } from '../logging/logic/logging.service';
import { Resetable } from './resetable';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from '../communication/logic/commumication.service';
import { LoadingService } from '../loading/loading.service';
import { AlertService } from '../alert/alert.service';
import { CredentialsLogicService } from '../credentials/logic/credentials/credentials-logic.service';
import { CredentialsService } from '../credentials/logic/credentials.service';

@Injectable()
export class ResetterService implements Resetable {
  constructor(
    private logger: LoggingService,
    private resetables: Resetable,
    private translate: TranslateService,
    private commService: CommunicationService,
    private loadingService: LoadingService,
    private alertService: AlertService,
  ) {}

  public async reset() {
    let title = await this.translate.get('COMMON.RESET.TITLE').toPromise();
    let message = await this.translate.get('COMMON.RESET.MESSAGE').toPromise();
    let confirm = await this.translate.get('COMMON.RESET.CONFIRM').toPromise();

    await this.alertService.showAlert(
      title,
      null,
      message,
      confirm,
      this.resetServices.bind(this),
    );
  }

  public async hardreset() {
    let title = await this.translate.get('COMMON.HARD-RESET.TITLE').toPromise();
    let message = await this.translate
      .get('COMMON.HARD-RESET.MESSAGE')
      .toPromise();
    let confirm = await this.translate
      .get('COMMON.HARD-RESET.CONFIRM')
      .toPromise();

    await this.alertService.showAlert(
      title,
      null,
      message,
      confirm,
      this.clearServices.bind(this, true),
    );
  }

  public async clear() {
    let title = await this.translate.get('COMMON.CLEAR.TITLE').toPromise();
    let message = await this.translate.get('COMMON.CLEAR.MESSAGE').toPromise();
    let confirm = await this.translate.get('COMMON.CLEAR.CONFIRM').toPromise();

    await this.alertService.showAlert(
      title,
      null,
      message,
      confirm,
      this.clearServices.bind(this),
      undefined,
      undefined,
      true,
      'danger',
    );
  }

  // Private Functions
  private async resetServices() {
    await this.loadingService.showLoading();

    if (this.resetables instanceof Array) {
      this.logger.log(this.constructor.name, '- Start reseting services');
      for (const restable of this.resetables) {
        this.logger.log(
          this.constructor.name,
          '- Reset service',
          restable.constructor.name,
        );
        try {
          await restable.reset();
        } catch (error) {
          this.logger.error(
            this.constructor.name,
            '- Error while resetting',
            restable.constructor.name,
            error?.message,
          );
        }
      }
      this.logger.log(this.constructor.name, '- Finished resetting services');
    }

    await this.loadingService.dismissLoading();
  }

  private async clearServices(hardReset = false) {
    await this.loadingService.showLoading();

    if (this.resetables instanceof Array) {
      this.logger.log(this.constructor.name, '- Start clearing services');
      for (const resetable of this.resetables) {
        try {
          if (hardReset && resetable instanceof CredentialsLogicService) {
            continue;
          }
          this.logger.log(
            this.constructor.name,
            '- Clear service',
            resetable.constructor.name,
          );
          await resetable.clear();
        } catch (error) {
          this.logger.error(
            this.constructor.name,
            '- Error while clearing',
            resetable.constructor.name,
            error?.message,
          );
        }
      }
      this.logger.log(this.constructor.name, '- Finished clearing services');
    }

    await this.loadingService.dismissLoading();
  }
}
